import { render, staticRenderFns } from "./ticketDetail.vue?vue&type=template&id=b9103492&scoped=true&"
import script from "./ticketDetail.vue?vue&type=script&lang=js&"
export * from "./ticketDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9103492",
  null
  
)

export default component.exports